
import { mapState, mapGetters, mapMutations, mapActions } from "vuex";
import XHeader from 'vux/src/components/x-header/index.vue'

import { routerNames } from "@/common/js/const";
import { getUrlKey } from "@/common/js/common";

export default {
name: routerNames.HomeIndex,
components: {
XHeader
},
/**计算属性 将状态表中的数据 映射出来*/
computed: {
...mapState({

userInfo: state => state.common.userInfo,
demoT: state => state.common.demoT
})


},
data() {
return {
url: "xxxxx",
recordNumber: '沪ICP备15034889号-3',
};
},
created() {},
activated() {
/*
微信卡包授权页结束后，由微信跳转而来的页面会被微信去掉/#后面的页面链接。在这个页面统一处理跳转
1.发票详情页手动插卡包
2.开票后自动插卡包
*/
var $self = this;
const queryStr = window.location.href;
const redirectUrl = getUrlKey(queryStr, "re");
if (redirectUrl == routerNames.OrderInvoiceIndex) {
$self.$router.replace("/orderInvoice/index");
} else if (redirectUrl == routerNames.OrderInvoiceDetail) {
let invoiceId = getUrlKey(queryStr, "id");
$self.$router.replace("/orderInvoice/detail/" + invoiceId);
}  else if (redirectUrl == routerNames.OrderInvoiceSuccess) {
let br = getUrlKey(queryStr, "br");
let orderId = getUrlKey(queryStr, "orderId");
let orderNo = getUrlKey(queryStr, "orderNo");
$self.$router.replace({
path:"/orderInvoice/success/",
query:{br,orderId, orderNo}});
} else {
let code = getUrlKey(queryStr, "code");
let state = getUrlKey(queryStr, "state");
if (state == "qixin") {
$self.$router.replace({
path: "/test/index",
query: {
code: code
}
});
}
}
},
/**计算属性 将状态表中的数据 映射出来*/
computed: {},
/**初始化的时候调用  类似于 ready */
mounted() {
const currentURL = window.location.href
if (currentURL.includes('e-fp.cn')) {
this.recordNumber = '沪ICP备15034889号-4'
} else if (currentURL.includes('kaifapiao.com')) {
this.recordNumber = '沪ICP备15034889号-5'
} else {
this.recordNumber = '沪ICP备15034889号-3'
}
},
methods: {}
};
